import $ from 'jquery';
import Cards from '@/lib/cards.js';
import { mountVueComponent } from '@/lib/mount-vue-component';
import OpenRounds from '@/lib/open-rounds.js';

export default function () {
	new OpenRounds();

	const cards = new Cards();
	cards.setup('ul.cards', 'li', 'masonry');

	$('.filtertron').filtertron('entries', {
		expander: '#filtertronExpander',
		cards: cards,
	});

	import('@/lib/components/Shared/ToggleSwitch.vue').then((toggleSwitch) => {
		mountVueComponent('toggle-switch', toggleSwitch);
	});

	import('@/lib/components/Shared/HelpIcon.vue').then((helpIcon) => {
		mountVueComponent('help-icon', helpIcon);
	});
}
